"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackMenuItemClick = trackMenuItemClick;
var _analytics = require("@cian/analytics");
var _types = require("../types");
var _topMenu = require("../constants/topMenu");
const mapTargetPageToCategory = {
  [_types.ETargetPage.valuationAgentResults]: 'valuation_by_realtor',
  [_types.ETargetPage.valuation]: 'valuation_main',
  [_types.ETargetPage.valuationResults]: 'valuation_result',
  //Эти два намеренно одинаковые. valuationResults устарел
  [_types.ETargetPage.valuationForAgentCalculatorPage]: 'valuation_result',
  [_types.ETargetPage.newBuilding]: 'valuation_newbuilding',
  [_types.ETargetPage.realtorPromo]: 'valuation_realtor_promo',
  [_types.ETargetPage.myHomePage]: 'my_home_page',
  [_types.ETargetPage.myHomeCard]: 'my_home_card'
};
const mapMenuItemToLabel = {
  [_topMenu.EMenuItems.Buy]: 'Tab/sale',
  //Это не я перепутал Buy и Sale, это так в доке и на главной
  [_topMenu.EMenuItems.Rent]: 'Tab/rent',
  [_topMenu.EMenuItems.Daily]: 'Tab/daily',
  [_topMenu.EMenuItems.Calculate]: 'Tab/calculate',
  [_topMenu.EMenuItems.Mortgage]: 'Tab/mortgage',
  [_topMenu.EMenuItems.Realtor]: 'Tab/realtor'
};
function trackMenuItemClick(targetPage, menuItem) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: mapTargetPageToCategory[targetPage],
    action: 'Click',
    label: mapMenuItemToLabel[menuItem]
  });
}